import { ref } from "vue";
import { useUserStore } from "@/store";
import { CUSTOMER_FEATURE_FLAG_NAME } from "@/global/constants";

export const UAM_NOTIFICATION_HEADER_KEYS = {
  PARTIAL_DATA: "partial-data",
  SHARED_LIMIT_WARNING: "shared-limit-warning"
} as const;

export const UAM_NOTIFICATION_CONFIG = {
  PARTIAL_DATA: {
    appearance: "error" as const,
    headingKey: "UAM.PARTIAL_DATA_BANNER_HEADING",
    bodyKey: "UAM.PARTIAL_DATA_BANNER_BODY"
  },
  SHARED_LIMIT_WARNING: {
    appearance: "warning" as const,
    headingKey: "UAM.SHARED_LIMIT_WARNING_BANNER_HEADING",
    bodyKey: "UAM.SHARED_LIMIT_WARNING_BANNER_BODY"
  }
} as const;

export type UamNotificationKey = keyof typeof UAM_NOTIFICATION_CONFIG | null;

export const useUamNotification = () => {
  const { isCustomerFeatureFlagEnabled } = useUserStore();

  const notificationKey = ref<UamNotificationKey>(null);

  const handleResponseHeaders = (headers: Record<string, string | number | undefined> | undefined) => {
    if (!headers || !isCustomerFeatureFlagEnabled(CUSTOMER_FEATURE_FLAG_NAME.UAM_UI_ENABLED)) return;

    if (headers[UAM_NOTIFICATION_HEADER_KEYS.PARTIAL_DATA] === "true") {
      notificationKey.value = "PARTIAL_DATA";
    } else if (headers[UAM_NOTIFICATION_HEADER_KEYS.SHARED_LIMIT_WARNING] === "true") {
      notificationKey.value = "SHARED_LIMIT_WARNING";
    } else {
      notificationKey.value = null;
    }
  };

  return { notificationKey, handleResponseHeaders };
};
